(function(){
  var DURATION = 3000;          // total load time before the page is revealed
  var CYCLE    = 2400;          // spark sweep cycle (matches the CSS animations)
  var TRIGGER  = 0.80;          // discharge fires at 80% of each cycle
  var field = document.getElementById('sparkField');
  var pct   = document.getElementById('pct');
  var fill  = document.getElementById('fill');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var done = false;

  /* --- spark burst at the bolt --- */
  function burst(n){
    for(var i=0;i<n;i++){
      var streak = Math.random() < 0.45;
      var el = document.createElement('div');
      el.className = 'p ' + (streak ? 'streak' : 'dot');
      var ang = (-70 + Math.random()*150) * Math.PI/180;   // spray up & right
      var dist = 26 + Math.random()*72;
      var tx = Math.cos(ang)*dist, ty = Math.sin(ang)*dist - 8;
      el.style.setProperty('--tx', tx.toFixed(1)+'px');
      el.style.setProperty('--ty', ty.toFixed(1)+'px');
      var life = 420 + Math.random()*320;
      el.style.animation = 'fly ' + life + 'ms cubic-bezier(.15,.7,.3,1) forwards';
      if(streak) el.style.rotate = (Math.atan2(ty,tx)*180/Math.PI)+'deg';
      field.appendChild(el);
      setTimeout((function(node){return function(){node.remove();};})(el), life+40);
    }
  }

  /* --- finish: flare, then fade the page in --- */
  function finish(){
    if(done) return; done = true;
    cancelAnimationFrame(raf);
    pct.textContent = '100%'; fill.style.width = '100%';
    if(!reduce) burst(36);
    document.getElementById('loader').classList.add('done');
    document.getElementById('page').classList.add('show');
  }

  if(reduce){
    pct.textContent = '100%'; fill.style.width = '100%';
    setTimeout(finish, DURATION);
    return;
  }

  /* --- linear charge to 100% over DURATION; sparks loop in sync with the CSS --- */
  var start = performance.now();
  var lastPhase = 0, raf;
  function loop(now){
    var t = now - start;
    var p = Math.min(1, t / DURATION);
    pct.textContent = Math.round(p*100) + '%';
    fill.style.width = (p*100) + '%';

    var phase = (t % CYCLE) / CYCLE;
    if(lastPhase < TRIGGER && phase >= TRIGGER){ burst(16); }  // discharge each cycle
    lastPhase = phase;

    if(t >= DURATION){ finish(); return; }
    raf = requestAnimationFrame(loop);
  }
  raf = requestAnimationFrame(loop);

  /* For a real site, gate the reveal on the actual page load too:
     var loaded = false; window.addEventListener('load', function(){ loaded = true; });
     ...and only call finish() once (t >= DURATION && loaded). */
})();